export default {
  "uploadLogLast20Lines": "Upload log (last 20 lines)",
  "closeLogViewer": "Close log viewer",
  "noLogEntriesFound": "No log entries found.",
  "uploadTriggered": "Upload triggered",
  "rcloneWillSyncYourFilesNow": "rclone will sync your files now.",
  "uploadFailed": "Upload failed",
  "unknownError": "Unknown error",
  "networkError": "Network error",
  "couldNotLoadLogs": "Could not load logs",
  "lockRemoved": "Lock removed",
  "uploadLockClearedRcloneCanRunAgain": "Upload lock cleared — rclone can run again.",
  "failedToRemoveLock": "Failed to remove lock",
  "cloudSyncRclone": "Cloud Sync (rclone)",
  "encrypted": "Encrypted",
  "close": "Close",
  "loadingRcloneStatus": "Loading rclone status…",
  "couldNotLoadStatus": "Could not load status —",
  "notConfiguredSetUpARemoteProviderToStart": "Not configured — set up a remote provider to start syncing.",
  "uploadLocked": "Upload locked",
  "lastUpload": "Last upload:",
  "noUploadsYet": "No uploads yet",
  "hideLogs": "Hide Logs",
  "viewLogs": "View Logs",
  "removeLock": "Remove Lock",
  "reAuthorize": "Re-authorize",
  "noDownloadClients": "No download clients",
  "downloads": "Downloads",
  "countOfDownloadsEachClientIsActivelyWorkingOn": "Count of downloads each client is actively working on. Click a client to browse its finished files.",
  "active": "active",
  "liveDataUnavailableShowingCachedCounts": "Live data unavailable — showing cached counts",
  "liveDataUnavailableShowingCachedCounts2": "Live data unavailable, showing cached counts",
  "viewAll": "View all",
  "unableToLoadDiskUsage": "Unable to load disk usage.",
  "unableToLoadSystemMetrics": "Unable to load system metrics.",
  "unexpectedSystemMetricsResponse": "Unexpected system metrics response.",
  "userAccountNotFound": "User account not found",
  "yourDashboardAccountDoesnTHaveALinuxUser": "Your dashboard account doesn't have a Linux user account on this server.",
  "cPU": "CPU",
  "sampling": "Sampling…",
  "memory": "Memory",
  "unableToLoadMonitoredPaths": "Unable to load monitored paths.",
  "unableToLoadMonitoredPaths2": "Unable to load monitored paths",
  "unableToAddPath": "Unable to add path.",
  "mountPathAdded": "Mount path added",
  "unableToAddPath2": "Unable to add path",
  "unableToRemovePath": "Unable to remove path.",
  "pathRemoved": "Path removed",
  "unableToRemovePath2": "Unable to remove path",
  "scanFailed": "Scan failed.",
  "sizesMayBeSlightlyUnderReported": "Sizes may be slightly under-reported.",
  "unreadableSamples": "Unreadable samples:",
  "scanComplete": "Scan complete",
  "usageResultsUpdated": "Usage results updated.",
  "scanCancelled": "Scan cancelled",
  "unableToScanPath": "Unable to scan path",
  "customPathMonitoring": "Custom Path Monitoring",
  "trackDirectoryUsageOverTimeAndTriggerOnDemand": "Track directory usage over time and trigger on-demand scans.",
  "adminMode": "Admin mode:",
  "youCanMonitorAnyPathOnTheServerUsing": "You can monitor any path on the server using absolute paths.",
  "scansRunInTheBackgroundAndMayTakeA": "Scans run in the background and may take a while on large directories.",
  "path": "Path",
  "labelOptional": "Label (optional)",
  "ignoreQuotas": "Ignore quotas",
  "useFilesystemTotalsInsteadOfUserQuotas": "Use filesystem totals instead of user quotas.",
  "enabled": "Enabled",
  "includeInMonitoringAndScans": "Include in monitoring and scans.",
  "addPath": "Add Path",
  "monitoredPaths": "Monitored Paths",
  "refresh": "Refresh",
  "lastSize": "Last Size",
  "lastScan": "Last Scan",
  "status": "Status",
  "actions": "Actions",
  "noMonitoredPathsYetAddOneAboveToStart": "No monitored paths yet. Add one above to start tracking usage.",
  "disabled": "Disabled",
  "scanning": "Scanning...",
  "scan": "Scan",
  "cancel": "Cancel",
  "cloudSync": "Cloud Sync",
  "remoteIsEncrypted": "Remote is encrypted",
  "unavailable": "Unavailable",
  "manageCloudSyncSettings": "Manage Cloud Sync settings",
  "manage": "Manage",
  "diskUsageView": "Disk usage view",
  "system": "System",
  "quota": "Quota",
  "cloud": "Cloud",
  "viewingAlternateMountClickToReset": "Viewing alternate mount. Click to reset.",
  "override": "Override",
  "selectMountToDisplay": "Select mount to display",
  "systemMounts": "System Mounts",
  "selectAMountToDisplay": "Select a mount to display",
  "used": "% used",
  "resetToDefault": "Reset to default",
  "usage": "Usage",
  "freeCloudStorageRemaining": "Free cloud storage remaining",
  "free": "free",
  "cloudMountInactive": "Cloud mount inactive",
  "freeSpaceRemaining": "Free space remaining",
  "noDiskDataAvailable": "No disk data available",
  "configure": "Configure",
  "failedToFetchRcloneStatus": "Failed to fetch rclone status",
  "viewLabelDownloads": "View {{label}} downloads",
  "coresCThreadsT": "{{cores}}C / {{threads}}T",
  "loadLoadTuple": "Load: {{loadTuple}}",
  "memUserRssBytesUsed": "{{memUserRssBytes}} used",
  "memoryTotalBytesTotal": "{{memoryTotalBytes}} total",
  "primaryMountPathMountPath": "Primary mount path: {{mountPath}}",
  "remainingCount": "And {{count}} more…",
  "monitorInside": "You can monitor folders inside {{path}}.",
  "bytesFree": "{{bytes}} free",
  "activeDownloadsCount": "Active: {{count}}",
  "mounted": "Mounted",
  "notMounted": "Not mounted",
  "triggered": "Triggered",
  "uploadNow": "Upload Now",
  "scanCompletedWithWarnings": "Scan completed with warnings",
  "eGDownloads": "e.g. Downloads",
  "notScanned": "Not scanned",
  "storage": "Storage",
  "monitoredMountOne": "{{count}} monitored mount",
  "monitoredMountOther": "{{count}} monitored mounts"
} as const;
